import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type CreateWorkflowChangeRequestModalProps = {
    workflowName: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<WorkflowChangeRequest>;
};

export const CreateWorkflowChangeRequestModal = (props: CreateWorkflowChangeRequestModalProps) => {
    const { workflowName, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>
                    This action will <b>START</b> a new Change Request to MODIFY the Verification Workflow named <b>{workflowName}</b>.
                </p>
                <p>
                    You may CANCEL the Change Request at any time prior to deployment using the CANCEL option.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async (onModalClose: () => void) => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.CREATE}
            title={"Start Change Request"}
            body={bodyElement}
            buttonText={"Start Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};